import type { RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      { path: "", component: () => import("@/pages/ListShow.vue"), name: "home" },
      { path: "/login", component: () => import("@/pages/LoginPage.vue"), name: "login" },
      { path: "/lists", component: () => import("@/pages/ListsIndex.vue") },
      { path: "/departments", component: () => import("@/pages/DepartmentsIndex.vue") },
      { path: "/stores", component: () => import("@/pages/StoresIndex.vue") },
      { path: "/items", component: () => import("@/pages/ItemsIndex.vue") },
      { path: "/history/:id*", component: () => import("@/pages/ItemHistory.vue"), name: "history" },
      { path: "/list-items/new", component: () => import("@/pages/ListItemNew.vue") },
      { path: "/invite/:code", component: () => import("@/pages/UserNew.vue"), name: "invite" }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("@/pages/ErrorNotFound.vue")
  }
]

export default routes
